export const BRANDS = [
  '6A',
  'Andrea Boldrini',
  'Black Diamond',
  'Boreal',
  'Canin',
  'EB',
  'Evolv',
  'Five Ten',
  'Garra',
  'La Sportiva',
  'Mad Rock',
  'Millet',
  'Ocún',
  'Red Chili',
  'Scarpa',
  'Simond',
  'So Ill',
  'Tenaya',
  'Unparallel',
  'Wildclimb',
];

// Popular/flagship models per brand (2025/2026 lineups), sourced from brand
// catalogs and gear-review roundups — see .claude/CLAUDE.md §1.2. Brands
// entered manually via "Autre marque" have no entry here; ModelSelection
// falls back to just the "Autre modèle" input in that case.
export const MODELS_BY_BRAND = {
  '6A': ['Empire', 'Prime', 'Speedy', 'Buzz'],
  'Andrea Boldrini': ['Apache 5+', 'Spider', 'Testarossa', 'Lynx'],
  'Black Diamond': ['Momentum', 'Aspect', 'Shadow', 'Focus', 'Technician Pro'],
  Boreal: ['Joker', 'Diabola', 'Mutant', 'Alpha', 'Beta Eco'],
  Canin: ['Leader', 'Bloody', 'Sinaï', 'Tip Top'],
  EB: ['Electron 3.0', 'Guardian 3.0', 'Nebula', 'Django', 'Jarvis Elite'],
  Evolv: ['Shaman', 'Agro', 'Elektra', 'Defy', 'Phantom'],
  'Five Ten': ['Hiangle', 'Anasazi', 'Quantum', 'NIAD VCS'],
  Garra: ['Panther', 'Kamae', 'Unkai', 'Sensei', 'Kokoro'],
  'La Sportiva': ['Miura VS', 'Skwama', 'Katana Lace', 'Solution', 'Finale'],
  'Mad Rock': ['Remora Pro HV', 'Drone 2.0 HV', 'D2.ONE LV'],
  Millet: ['Easy Up', 'Siurana Evo'],
  Ocún: ['Jett', 'Bullit', 'Striker QC', 'Advancer QC'],
  'Red Chili': ['Voltage X', 'Voltage II', 'Voltage LV'],
  Scarpa: ['Drago XT', 'Instinct VSR', 'Vapor V', 'Boostic', 'Furia AIR'],
  Simond: ['Edge Soft', 'Edge', 'Vertika'],
  'So Ill': ['Stay', 'Street', 'Torque', 'Roam', 'Catch'],
  Tenaya: ['Mastia', 'Masai', 'Iati', 'Oasi'],
  Unparallel: ['Flagship', 'Leopard II', 'Quibit', 'Up Rise Pro'],
  Wildclimb: ['Pantera 2.0', 'Artemis', 'Bat', 'Dagara'],
};

export const MIN_SIZE = 24;
export const MAX_SIZE = 50;
export const SIZES = Array.from(
  { length: MAX_SIZE - MIN_SIZE + 1 },
  (_, i) => MIN_SIZE + i
);

export const GUMS = [
  {
    id: 'VIBRAM_XS_GRIP',
    label: 'Vibram® XS GRIP',
    description:
    "Gomme souple offrant une adhérence maximale, parfaite pour l'escalade en dalle et sur volumes. Moins durable et moins précise que la XS Edge sur les appuis fins.",
  },
  {
    id: 'VIBRAM_XS_GRIP_2',
    label: 'Vibram® XS GRIP 2',
    description:
    "Évolution de la XS Grip, elle combine une bonne adhérence avec une meilleure durabilité et un maintien plus précis. Un bon compromis polyvalent pour la plupart des styles de grimpe.",
  },
  {
    id: 'VIBRAM_XS_EDGE',
    label: 'Vibram® XS EDGE',
    description:
      "Gomme rigide offrant un excellent maintien sur les prises fines et le pied d'ancre. Idéale pour la grimpe technique en dévers et les voies sur petites réglettes, au prix d'une adhérence un peu moindre sur l'adhérence pure.",
  },
];

export const SERVICES = [
  {
    id: 'CLIMBING_RESSEMELAGE',
    label: 'Ressemelage',
    price: 45,
    description:
      'Remplacement de la semelle uniquement.',
    notice:
      "L'atelier se réserve le droit de facturer un « Enrobage et ressemelage » si l'état du chausson le nécessite.",
  },
  {
    id: 'CLIMBING_ENROBAGE',
    label: 'Enrobage et ressemelage',
    price: 57,
    description:
      'Remplacement de la semelle et renfort du contour (enrobage) du chausson.',
  },
];

export const DELIVERY_FEE = 1;

// Ticket numbers are generated as "04-01-XXX" for now, see utils/ticketNumber.js.
export const TICKET_PREFIX = '04-01-';

export const TICKET_STATUS_ORDER = [
  'CART_PENDING',
  'QUOTE_SENT',
  'PAYED',
  'CONTROLLED',
  'DELIVERED',
];

export const TICKET_STATUS_LABELS = {
  CART_PENDING: 'En attente de collecte',
  QUOTE_SENT: 'En attente de paiement',
  PAYED: 'En cours de réparation',
  CONTROLLED: 'En attente de livraison',
  DELIVERED: 'Livré dans votre salle',
};

// Mock order-tracking lookup for development purposes only, keyed by the full
// ticket number — no backend endpoint exists yet, see .claude/CLAUDE.md.
export const MOCK_TRACKED_ORDERS = {
  '04-01-001': {
    status: 'CART_PENDING',
    shoe: {
      brand: 'Scarpa',
      model: 'Instinct VSR',
      size: 42,
      gum: 'VIBRAM_XS_EDGE',
      service: 'CLIMBING_RESSEMELAGE',
    },
  },
  '04-01-002': {
    status: 'QUOTE_SENT',
    shoe: {
      brand: 'La Sportiva',
      model: 'Skwama',
      size: 38,
      gum: 'VIBRAM_XS_GRIP',
      service: 'CLIMBING_ENROBAGE',
    },
  },
  '04-01-003': {
    status: 'PAYED',
    shoe: {
      brand: 'Black Diamond',
      model: 'Momentum',
      size: 40,
      gum: 'VIBRAM_XS_GRIP_2',
      service: 'CLIMBING_RESSEMELAGE',
    },
  },
  '04-01-004': {
    status: 'CONTROLLED',
    shoe: {
      brand: 'Boreal',
      model: 'Joker',
      size: 39,
      gum: 'VIBRAM_XS_EDGE',
      service: 'CLIMBING_ENROBAGE',
    },
  },
  '04-01-005': {
    status: 'DELIVERED',
    shoe: {
      brand: 'Evolv',
      model: 'Shaman',
      size: 41,
      gum: 'VIBRAM_XS_GRIP',
      service: 'CLIMBING_RESSEMELAGE',
    },
  },
};
